import * as React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TableRow from "@material-ui/core/TableRow";
import Link from "@material-ui/core/Link";
import { Information } from "../../components/core";
import moment from "moment";
import { PanelExpand } from "../../components";
import { msg } from '../../components/Notifications/MsgBox';

const ExtendConsiderationPeriodItem = ({ item, onSearch, messageSearchError, showValidate = false, attachments, onDeleteAttachment, onChangeItem, logs, canEdit = false, newConsiderDate }) => {

  const handleSearch = () => {
    if(typeof onSearch === 'function')
    {
      onSearch(item.po_contract_no);
    }
  }

  const handleOnChange = (event) => {


    console.log('handleOnChange',  event.target)
    const target = event.target
    let value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value
    const name = target.name

    //check date
    if (target.className) {
        if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
            let dateData = (value.toString()).split("/")
            let dateDataLength = dateData.length
            if (dateDataLength === 3) {
                if (moment(value, 'DD/MM/YYYY').isValid()) {
                    value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }
            }
        }
    }

    if(typeof onChangeItem === 'function')
    {
      onChangeItem(name, value)
    }
}

  function openAttachedDocumentNormalModal(transaction_change_no) {
    window.$('#attachedChangeCommitteeModal').modal('show');

  }

  const handleOnDeleteConfirmAttachmen = (event, item, index) => {
    if (index != null) {
        msg.showConfirm(
            "Confirm",
            "ต้องการลบรายการนี้หรือไม่",
            () => {
                msg.hideConfirm()

                if(typeof onDeleteAttachment === 'function')
                {
                  onDeleteAttachment(item)
                }
                msg.success("ลบรายการสำเร็จ")
            },
            () => {
                msg.hideConfirm()
                //console.log("ยกเลิกการลบรายการ")
            },
            () => {
                //console.log("ยกเลิกการลบรายการ")
            }
        )
    }
}
 

  return (
    <div  className="tor tor-template-list">
      <div className="row">
        <div className="col-md-9">
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <div
                  className="rrs-detail-data"
                  style={{ textAlign: "left" }}
                ></div>
              </div>
            </div>
            <div className="col-md-10">
              <div className="form-group">
                <div
                  className="rrs-detail-data"
                  style={{ textAlign: "left" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label " style={{ color: '#0036C1', fontWeight: 'bold' }}>Status : </label>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                <text style={{ color: item.status == 'REJECT' ? '#ff0000' :'#2D9714' }}>{item.status_name ?? 'Draft'}</text>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="form-group">
                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                {
                                                    item.status == 'REJECT' ? (<input
                                                        type="text"
                                                        id="reason"
                                                        name="reason"
                                                        className="form-control"
                                                        defaultValue={item.reason ?? ''}
                                                        disabled={true}
                                                    />) : ('')
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
      <div className="row">
        <div className="col-md-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <span style={{ color: "red" }}>* </span>
            <label className="rrs-label ">PO/Contract No. : </label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              <input
                type="text"
                id="po_contract_no"
                name="po_contract_no"
                className="form-control"
                placeholder="ข้อมูล Purchase / Contract Number"
                defaultValue={item.po_contract_no ?? ''}
                // onBlur={handleChange}
                onChange={handleOnChange}
                autoComplete="off"
                disabled={!canEdit}
              />
              {/* {showErrorPOContractNo && <FormLabel className="Mui-error">ไม่พบข้อมูล</FormLabel>} */}
            </div>
          </div>
        </div>
        {([''].includes(item.status) || item.status === null || item.status === undefined) && item && canEdit &&<div className="col-md-1">
         <a onClick={handleSearch} style={{ cursor: 'pointer' }} disabled={true}>
            <i className="icon bt-search icon-xs" />
          </a>
        </div>}
      </div>

      { messageSearchError && <div className="row">
        <div className="col-md-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <label className="rrs-label ">&nbsp;</label>
          </div>
        </div>
        <div className="col-md-9">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              <Typography color="error">{messageSearchError}</Typography>
            </div>
          </div>
        </div>
      </div>}

      <div className="row">
        <div className="col-md-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <label className="rrs-label ">ชื่องาน : </label>
          </div>
        </div>
        <div className="col-md-9">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              <input
                type="text"
                id="po_header_text"
                name="po_header_text"
                className="form-control"
                value={item.po_header_text ?? ''}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <label className="rrs-label ">ผู้บันทึกข้อมูล : </label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              <input
                type="text"
                id="create_by_name"
                name="create_by_name"
                className="form-control"
                value={item.create_by ? `${item.create_by_name} (${item.create_by})` : ``}
                // value ={stateChangeCommittee.requester_code != '' ? stateChangeCommittee.requester_fullname + ' (' + stateChangeCommittee.requester_code + ')' : emp.employeeNameTH + ' (' + emp.employeeId + ')'}
                // onChange={handleChange}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{marginBottom: 15}}>
        <div className="col-sm-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <label className="rrs-label ">กำหนดระยะเวลาพิจารณาเดิม : </label>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <Typography align="center" style={{paddingRight: '0.75rem'}}>{item.consideration_period_original}</Typography>
          </div>
        </div>
        <div className="col-sm-7">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              วันทำการ นับถัดจากวันที่ส่งมอบถูกต้องครบถ้วน
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
          <span style={{ color: "red" }}>* </span>
            <label className="rrs-label ">จำนวนวันที่ขอขยายเวลาพิจารณา : </label>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
            <input
                type="number"
                id="consideration_period_new"
                name="consideration_period_new"
                className="form-control"
                style={{textAlign:'center'}}
                defaultValue={item.consideration_period_new}
                onBlur={handleOnChange}
                onChange={handleOnChange}
                disabled={!canEdit}
              />
            </div>
            { showValidate && !item.reason && <Typography color="error">กรุณาระบุ จำนวนวันที่ขอขยายเวลาพิจารณา</Typography>}
          </div>
        </div>
        <div className="col-sm-7">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              วันทำการ ครบกำหนดระยะเวลาพิจารณาใหม่ในวันที่ {newConsiderDate ? moment(newConsiderDate).format('DD/MM/yyyy'): ''} <Information>วันที่ครบกำหนดระยะเวลาพิจารณาใหม่ อ้างอิงตามใบงาน MoM ที่ถึงกำหนดวันสิ้นสุดการพิจารณาเป็นลำดับแรก ทั้งนี้ การขยายระยะเวลา จะมีผลกับ MoM ทุกใบงานที่มีเลขที่ PO เดียวกัน</Information>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="rrs-detail-data" style={{ textAlign: "right" }}>
            <span style={{ color: "red" }}>* </span>
            <label className="rrs-label ">สาเหตุการขอขยายเวลาพิจารณา : </label>
          </div>
        </div>
        <div className="col-md-9">
          <div className="form-group">
            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
              <input
                type="text"
                id="reason"
                name="reason"
                className="form-control"
                defaultValue={item.reason ?? ''}
                onBlur={handleOnChange}
                onChange={handleOnChange}
                disabled={!canEdit}
              />
            </div>
            { showValidate && !item.reason && <Typography color="error">กรุณาระบุ สาเหตุการขอขยายเวลาพิจารณา</Typography>}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <PanelExpand
            title="History ขยายระยะเวลาพิจารณา"
            titleStyle={{ fontWeight: "100", color: "#004290", fontSize: 16 }}
            divStyle={{ paddingBottom: 10 }}
          >
            <React.Fragment>
              <Grid container>
                <Grid item xs={12}>
                  <Table className="sp-table table rrs-table">
                    <TableHead>
                      <TableRow
                        className="sp-table-header"
                        style={{ backgroundColor: "#B6D0FB" }}
                      >
                        <TableCell
                          className="th-table text-center"
                          style={{ width: "200px" }}
                        >
                          ดำเนินการวันที่
                        </TableCell>
                        <TableCell
                          className="th-table text-center"
                          style={{ width: "250px" }}
                        >
                          ดำเนินการโดย
                        </TableCell>
                        <TableCell className="th-table text-center">
                          รายละเอียด
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      { logs.map((log)=>(<TableRow>
                        <TableCell className="th-table text-center">
                          {moment(log.action_date).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell className="th-table text-left">
                          {log.action_by_name} ({log.action_by_code})
                        </TableCell>
                        <TableCell className="th-table text-left">
                          {log.comment}
                        </TableCell>
                      </TableRow>))}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </React.Fragment>
          </PanelExpand>
        </div>
      </div>
      <div className="row">
    
        <div className="col-md-12">
          <PanelExpand
            title={
              <>
                <span style={{ color: "red" }}>*</span>
                <span> เอกสารอ้างอิงคำขอขยายระยะเวลาพิจารณา</span>
              </>
            }
            titleStyle={{ fontWeight: "100", color: "#004290", fontSize: 16 }}
            divStyle={{ paddingBottom: 10 }}
          >
            <React.Fragment>
              <Grid container>
                { item.po_header_text && canEdit === true &&  <Grid item xs={12} style={{textAlign: 'right'}}>
                    <a style={{ cursor: 'pointer' }} onClick={() => openAttachedDocumentNormalModal('x')}>
                          <i className="icon btn-order-upload" />
                      </a>
                </Grid>}
                <Grid item xs={12}>
                  <Table className="sp-table table rrs-table">
                    <TableHead>
                      <TableRow
                        className="sp-table-header"
                        style={{ backgroundColor: "#0072BC" }}
                      >
                        <TableCell
                          className="th-table text-center"
                          style={{ color: "#FFFFFF" }}
                        >
                          No.
                        </TableCell>
                        <TableCell
                          className="th-table text-left"
                          style={{ color: "#FFFFFF" }}
                        >
                          ชื่อเอกสารแนบ
                        </TableCell>
                        <TableCell
                          className="th-table text-left"
                          style={{ color: "#FFFFFF" }}
                        >
                          คำอธิบาย
                        </TableCell>
                        { canEdit === true && <TableCell className="th-table text-center" style={{color: '#FFFFFF' }}>ลบ</TableCell>}
                        { canEdit === true && <TableCell
                          className="th-table text-center"
                          style={{ color: "#FFFFFF" }}
                        >
                          แสดง
                        </TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        attachments.filter(p=> p.isActive === true).map((attach, index)=>(<TableRow key={index}>
                          <TableCell className="text-center" style={{ width: '10%' }}>{index + 1}</TableCell>
                          <TableCell className="text-left" style={{ width: '25%' }}>{canEdit ? attach.file_name : <Link variant="body2" target="_blank" rel="noreferrer" href={attach.file_url}>{attach.file_name}</Link>}</TableCell>

                          <TableCell className="text-left" >{attach.file_description}</TableCell>
                       
                          { canEdit === true && <TableCell className="text-center" style={{ width: '10%' }}>
                              <a onClick={(event) => handleOnDeleteConfirmAttachmen(event, attach, index)}><i className="icon btn-minus" /></a>
                          </TableCell>}
                        
                          { canEdit === true && <TableCell className="text-center" style={{ width: '10%' }}><a href={attach.file_url} target="_blank" rel="noopener"><i className="icon icon-preview-eye-blue" /></a></TableCell>}
                      </TableRow>))
                      }
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </React.Fragment>
          </PanelExpand>
        </div>
      </div>

     
    </div>
  );
};

export default ExtendConsiderationPeriodItem;
